export { appendIf, is, moreThanOne, zeroCount };

/**
 * Check if something is something else
 */
function is(item1: any, item2: any) {
  return item1 === item2;
}

/**
 * Check if count of piece is zero
 */
function zeroCount(count: number) {
  return count === 0;
}

/**
 * Check if count of piece is more than one
 */
function moreThanOne(count: number) {
  return count > 1;
}

/**
 * Append classes to element if condition is true
 */
function appendIf(classConditions: { [s: string]: unknown } | ArrayLike<unknown>) {
  return Object.entries(classConditions)
    .reduce((classes: string[], [className, condition]) => {
      if (condition) {
        classes.push(className);
      }

      return classes;
    }, [])
    .join(' ');
}
